module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_12.07fed5b9.jpg";